/**
 * ANQ.ContentServiceManagement.API 
 * Content Service Mgt API
 *
 * OpenAPI spec version: v1
 * Contact: support@coure-tech.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { AddContentServiceProvider } from '../model/addContentServiceProvider';
import { ContentServiceProviders } from '../model/contentServiceProviders';
import { ProblemDetails } from '../model/problemDetails';
import { ServiceProviderContentsCountDto } from '../model/serviceProviderContentsCountDto';
import { ServiceProviderListAndCountDto } from '../model/serviceProviderListAndCountDto';
import { ServiceProviders } from '../model/serviceProviders';
import { ServiceProvidersDto } from '../model/serviceProvidersDto';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class MapContentToServiceProividerService {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiMapContentToServiceProividerContentServiceProviderMapPost(body?: AddContentServiceProvider, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public apiMapContentToServiceProividerContentServiceProviderMapPost(body?: AddContentServiceProvider, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public apiMapContentToServiceProividerContentServiceProviderMapPost(body?: AddContentServiceProvider, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public apiMapContentToServiceProividerContentServiceProviderMapPost(body?: AddContentServiceProvider, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('post',`${this.basePath}/api/MapContentToServiceProivider/ContentServiceProviderMap`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiMapContentToServiceProividerGetAllByServiceProviderIdGet(id?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<ContentServiceProviders>>;
    public apiMapContentToServiceProividerGetAllByServiceProviderIdGet(id?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ContentServiceProviders>>>;
    public apiMapContentToServiceProividerGetAllByServiceProviderIdGet(id?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ContentServiceProviders>>>;
    public apiMapContentToServiceProividerGetAllByServiceProviderIdGet(id?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (id !== undefined && id !== null) {
            queryParameters = queryParameters.set('id', <any>id);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ContentServiceProviders>>('get',`${this.basePath}/api/MapContentToServiceProivider/GetAllByServiceProviderId`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param contentProviderName 
     * @param skip 
     * @param take 
     * @param search 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiMapContentToServiceProividerGetAllContentProviderClientsGet(contentProviderName?: string, skip?: number, take?: number, search?: string, observe?: 'body', reportProgress?: boolean): Observable<ServiceProviderListAndCountDto>;
    public apiMapContentToServiceProividerGetAllContentProviderClientsGet(contentProviderName?: string, skip?: number, take?: number, search?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ServiceProviderListAndCountDto>>;
    public apiMapContentToServiceProividerGetAllContentProviderClientsGet(contentProviderName?: string, skip?: number, take?: number, search?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ServiceProviderListAndCountDto>>;
    public apiMapContentToServiceProividerGetAllContentProviderClientsGet(contentProviderName?: string, skip?: number, take?: number, search?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {





        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (contentProviderName !== undefined && contentProviderName !== null) {
            queryParameters = queryParameters.set('contentProviderName', <any>contentProviderName);
        }
        if (skip !== undefined && skip !== null) {
            queryParameters = queryParameters.set('skip', <any>skip);
        }
        if (take !== undefined && take !== null) {
            queryParameters = queryParameters.set('take', <any>take);
        }
        if (search !== undefined && search !== null) {
            queryParameters = queryParameters.set('search', <any>search);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ServiceProviderListAndCountDto>('get',`${this.basePath}/api/MapContentToServiceProivider/GetAllContentProviderClients`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiMapContentToServiceProividerGetAllGet(observe?: 'body', reportProgress?: boolean): Observable<Array<ContentServiceProviders>>;
    public apiMapContentToServiceProividerGetAllGet(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ContentServiceProviders>>>;
    public apiMapContentToServiceProividerGetAllGet(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ContentServiceProviders>>>;
    public apiMapContentToServiceProividerGetAllGet(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ContentServiceProviders>>('get',`${this.basePath}/api/MapContentToServiceProivider/GetAll`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiMapContentToServiceProividerGetAllMappedContentByMapContentToServiceProviderIdGet(id?: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public apiMapContentToServiceProividerGetAllMappedContentByMapContentToServiceProviderIdGet(id?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public apiMapContentToServiceProividerGetAllMappedContentByMapContentToServiceProviderIdGet(id?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public apiMapContentToServiceProividerGetAllMappedContentByMapContentToServiceProviderIdGet(id?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (id !== undefined && id !== null) {
            queryParameters = queryParameters.set('id', <any>id);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('get',`${this.basePath}/api/MapContentToServiceProivider/GetAllMappedContentByMapContentToServiceProviderId`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param name 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiMapContentToServiceProividerGetAllMappedToContentByContentNameGet(name?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<ContentServiceProviders>>;
    public apiMapContentToServiceProividerGetAllMappedToContentByContentNameGet(name?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ContentServiceProviders>>>;
    public apiMapContentToServiceProividerGetAllMappedToContentByContentNameGet(name?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ContentServiceProviders>>>;
    public apiMapContentToServiceProividerGetAllMappedToContentByContentNameGet(name?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (name !== undefined && name !== null) {
            queryParameters = queryParameters.set('name', <any>name);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ContentServiceProviders>>('get',`${this.basePath}/api/MapContentToServiceProivider/GetAllMappedToContentByContentName`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param contentName 
     * @param ContentProviderName 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiMapContentToServiceProividerGetAllNotMappedToThisServiceByServiceProviderIdGet(contentName?: string, ContentProviderName?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<ServiceProviders>>;
    public apiMapContentToServiceProividerGetAllNotMappedToThisServiceByServiceProviderIdGet(contentName?: string, ContentProviderName?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ServiceProviders>>>;
    public apiMapContentToServiceProividerGetAllNotMappedToThisServiceByServiceProviderIdGet(contentName?: string, ContentProviderName?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ServiceProviders>>>;
    public apiMapContentToServiceProividerGetAllNotMappedToThisServiceByServiceProviderIdGet(contentName?: string, ContentProviderName?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (contentName !== undefined && contentName !== null) {
            queryParameters = queryParameters.set('contentName', <any>contentName);
        }
        if (ContentProviderName !== undefined && ContentProviderName !== null) {
            queryParameters = queryParameters.set('ContentProviderName', <any>ContentProviderName);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ServiceProviders>>('get',`${this.basePath}/api/MapContentToServiceProivider/GetAllNotMappedToThisServiceByServiceProviderId`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param serviceName 
     * @param serviceProviderName 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiMapContentToServiceProividerGetAllNotMappedToThisServiceByServiceProviderNameGet(serviceName?: string, serviceProviderName?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<ContentServiceProviders>>;
    public apiMapContentToServiceProividerGetAllNotMappedToThisServiceByServiceProviderNameGet(serviceName?: string, serviceProviderName?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ContentServiceProviders>>>;
    public apiMapContentToServiceProividerGetAllNotMappedToThisServiceByServiceProviderNameGet(serviceName?: string, serviceProviderName?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ContentServiceProviders>>>;
    public apiMapContentToServiceProividerGetAllNotMappedToThisServiceByServiceProviderNameGet(serviceName?: string, serviceProviderName?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (serviceName !== undefined && serviceName !== null) {
            queryParameters = queryParameters.set('serviceName', <any>serviceName);
        }
        if (serviceProviderName !== undefined && serviceProviderName !== null) {
            queryParameters = queryParameters.set('serviceProviderName', <any>serviceProviderName);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ContentServiceProviders>>('get',`${this.basePath}/api/MapContentToServiceProivider/GetAllNotMappedToThisServiceByServiceProviderName`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param contentId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiMapContentToServiceProividerGetAllSpByContentIdGet(contentId?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<ServiceProvidersDto>>;
    public apiMapContentToServiceProividerGetAllSpByContentIdGet(contentId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ServiceProvidersDto>>>;
    public apiMapContentToServiceProividerGetAllSpByContentIdGet(contentId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ServiceProvidersDto>>>;
    public apiMapContentToServiceProividerGetAllSpByContentIdGet(contentId?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (contentId !== undefined && contentId !== null) {
            queryParameters = queryParameters.set('contentId', <any>contentId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ServiceProvidersDto>>('get',`${this.basePath}/api/MapContentToServiceProivider/GetAllSpByContentId`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param authId 
     * @param skip 
     * @param take 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiMapContentToServiceProividerGetAllSpContentsByAuthIdGet(authId?: string, skip?: number, take?: number, observe?: 'body', reportProgress?: boolean): Observable<ServiceProviderContentsCountDto>;
    public apiMapContentToServiceProividerGetAllSpContentsByAuthIdGet(authId?: string, skip?: number, take?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ServiceProviderContentsCountDto>>;
    public apiMapContentToServiceProividerGetAllSpContentsByAuthIdGet(authId?: string, skip?: number, take?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ServiceProviderContentsCountDto>>;
    public apiMapContentToServiceProividerGetAllSpContentsByAuthIdGet(authId?: string, skip?: number, take?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {




        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (authId !== undefined && authId !== null) {
            queryParameters = queryParameters.set('authId', <any>authId);
        }
        if (skip !== undefined && skip !== null) {
            queryParameters = queryParameters.set('skip', <any>skip);
        }
        if (take !== undefined && take !== null) {
            queryParameters = queryParameters.set('take', <any>take);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ServiceProviderContentsCountDto>('get',`${this.basePath}/api/MapContentToServiceProivider/GetAllSpContentsByAuthId`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param authId 
     * @param skip 
     * @param take 
     * @param search 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiMapContentToServiceProividerGetAllSpContentsByAuthIdSearchGet(authId?: string, skip?: number, take?: number, search?: string, observe?: 'body', reportProgress?: boolean): Observable<ServiceProviderContentsCountDto>;
    public apiMapContentToServiceProividerGetAllSpContentsByAuthIdSearchGet(authId?: string, skip?: number, take?: number, search?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ServiceProviderContentsCountDto>>;
    public apiMapContentToServiceProividerGetAllSpContentsByAuthIdSearchGet(authId?: string, skip?: number, take?: number, search?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ServiceProviderContentsCountDto>>;
    public apiMapContentToServiceProividerGetAllSpContentsByAuthIdSearchGet(authId?: string, skip?: number, take?: number, search?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {





        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (authId !== undefined && authId !== null) {
            queryParameters = queryParameters.set('authId', <any>authId);
        }
        if (skip !== undefined && skip !== null) {
            queryParameters = queryParameters.set('skip', <any>skip);
        }
        if (take !== undefined && take !== null) {
            queryParameters = queryParameters.set('take', <any>take);
        }
        if (search !== undefined && search !== null) {
            queryParameters = queryParameters.set('search', <any>search);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ServiceProviderContentsCountDto>('get',`${this.basePath}/api/MapContentToServiceProivider/GetAllSpContentsByAuthIdSearch`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param serviceProviderId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiMapContentToServiceProividerGetAllSpMappedToContentByContentProviderIdGet(serviceProviderId?: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public apiMapContentToServiceProividerGetAllSpMappedToContentByContentProviderIdGet(serviceProviderId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public apiMapContentToServiceProividerGetAllSpMappedToContentByContentProviderIdGet(serviceProviderId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public apiMapContentToServiceProividerGetAllSpMappedToContentByContentProviderIdGet(serviceProviderId?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (serviceProviderId !== undefined && serviceProviderId !== null) {
            queryParameters = queryParameters.set('serviceProviderId', <any>serviceProviderId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('get',`${this.basePath}/api/MapContentToServiceProivider/GetAllSpMappedToContentByContentProviderId`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param name 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiMapContentToServiceProividerGetAllSpMappedToCpContentByContentProviderNameGet(name?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<ContentServiceProviders>>;
    public apiMapContentToServiceProividerGetAllSpMappedToCpContentByContentProviderNameGet(name?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ContentServiceProviders>>>;
    public apiMapContentToServiceProividerGetAllSpMappedToCpContentByContentProviderNameGet(name?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ContentServiceProviders>>>;
    public apiMapContentToServiceProividerGetAllSpMappedToCpContentByContentProviderNameGet(name?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (name !== undefined && name !== null) {
            queryParameters = queryParameters.set('name', <any>name);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ContentServiceProviders>>('get',`${this.basePath}/api/MapContentToServiceProivider/GetAllSpMappedToCpContentByContentProviderName`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiMapContentToServiceProividerGetByIdGet(id?: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public apiMapContentToServiceProividerGetByIdGet(id?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public apiMapContentToServiceProividerGetByIdGet(id?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public apiMapContentToServiceProividerGetByIdGet(id?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (id !== undefined && id !== null) {
            queryParameters = queryParameters.set('id', <any>id);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('get',`${this.basePath}/api/MapContentToServiceProivider/GetById`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param serviceProviderId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiMapContentToServiceProividerGetDistinctContentServiceProviderByServiceProviderIdGet(serviceProviderId?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<ContentServiceProviders>>;
    public apiMapContentToServiceProividerGetDistinctContentServiceProviderByServiceProviderIdGet(serviceProviderId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ContentServiceProviders>>>;
    public apiMapContentToServiceProividerGetDistinctContentServiceProviderByServiceProviderIdGet(serviceProviderId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ContentServiceProviders>>>;
    public apiMapContentToServiceProividerGetDistinctContentServiceProviderByServiceProviderIdGet(serviceProviderId?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (serviceProviderId !== undefined && serviceProviderId !== null) {
            queryParameters = queryParameters.set('serviceProviderId', <any>serviceProviderId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ContentServiceProviders>>('get',`${this.basePath}/api/MapContentToServiceProivider/GetDistinctContentServiceProviderByServiceProviderId`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiMapContentToServiceProividerRemoveContentServiceProviderDelete(body?: AddContentServiceProvider, observe?: 'body', reportProgress?: boolean): Observable<string>;
    public apiMapContentToServiceProividerRemoveContentServiceProviderDelete(body?: AddContentServiceProvider, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<string>>;
    public apiMapContentToServiceProividerRemoveContentServiceProviderDelete(body?: AddContentServiceProvider, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<string>>;
    public apiMapContentToServiceProividerRemoveContentServiceProviderDelete(body?: AddContentServiceProvider, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<string>('delete',`${this.basePath}/api/MapContentToServiceProivider/RemoveContentServiceProvider`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiMapContentToServiceProividerUpdatePut(body?: ContentServiceProviders, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public apiMapContentToServiceProividerUpdatePut(body?: ContentServiceProviders, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public apiMapContentToServiceProividerUpdatePut(body?: ContentServiceProviders, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public apiMapContentToServiceProividerUpdatePut(body?: ContentServiceProviders, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('put',`${this.basePath}/api/MapContentToServiceProivider/Update`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
